// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"e2af6d54","453":"c3db55c9","779":"e2af6d54","844":"0e4d9a03"}[chunkId] + ".chunk.js";
};